import service from "./upload"
import newService from "./newUpload"

export function uploadRequest(url,data){
    // debugger;
    return service({
        headers:{
            "content-type":"multipart/form-data"  //使用formData对象默认使用这个配置，不配置也行 用formData必须要有boundary ,这是浏览器自动生成的
        },
        method:"post",
        url:url,
        data
    })
}

export function uploadRequest2(url,data){
  // debugger;
  return newService({
    headers:{
      "content-type":"multipart/form-data"  //使用formData对象默认使用这个配置，不配置也行 用formData必须要有boundary ,这是浏览器自动生成的
    },
    method:"post",
    url:url,
    data
  })
}
